import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip } from 'antd';
import { CustomPercentageInputWrapper, InputControls } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { ExclamationCircleIcon } from '../../../custom_shared/icons';
import { TypeUtils } from '../../../common/misc';

const SystemSignedShareInput: InputWithoutSource = ({ input }) => {
    const explanationTooltip = (
        <Tooltip
            title={
                <span>
                    This is the System signed share for the <strong>Main Section</strong> in SICS.
                </span>
            }
            overlayStyle={{ maxWidth: 400 }}
            overlayInnerStyle={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
            placement="topRight"
        >
            <ExclamationCircleIcon width={17} height={17} color="black" />
        </Tooltip>
    );

    const { formattedValue, labelTooltip } = React.useMemo(() => {
        if (!TypeUtils.isNumber(input.value)) {
            return { formattedValue: undefined, labelTooltip: undefined };
        }

        return {
            formattedValue: input.value.toFixed(2),
            labelTooltip: `${input.value} %`
        };
    }, [input.value]);

    return (
        <CustomPercentageInputWrapper
            input={input}
            label={input.name + ' %'}
            labelTooltip={labelTooltip}
            value={formattedValue}
            topRightNode={<InputControls input={input} additionalLeftNode={explanationTooltip} />}
        />
    );
};

SystemSignedShareInput.meta = {
    inputType: InputModel.name
};

export default observer(SystemSignedShareInput);
